import { usePaymentSource } from '@zapier/payment';

import {
  useCurrentAccountId,
  useOffer,
  usePromoPlans,
} from '@zapier/promotions/src/hooks';

import { getOfferIdFromUrl } from './getOfferIdFromUrl';

export type UseOfferModalProps = {
  offerId?: string | null | undefined;
  onAcceptOfferSuccess?: () => void;
};

export const useOfferModal = ({
  offerId: offerIdProp,
  onAcceptOfferSuccess = () => {},
}: UseOfferModalProps) => {
  const { accountId } = useCurrentAccountId();
  const offerId = offerIdProp || getOfferIdFromUrl();
  const canShow = Boolean(accountId && !!offerId);

  const {
    acceptOffer,
    error,
    isLoading: isLoadingOffer,
    isOfferActive,
    isOfferAvailable,
    isSaving,
    offer,
    offerEndDate,
  } = useOffer({
    offerId,
    onAcceptOfferSuccess,
  });

  const {
    isLoading: isLoadingPaymentSource,
    primarySource,
  } = usePaymentSource({ accountId });

  const {
    allowIntervalSelection,
    isLoading: isLoadingPromoPlans,
    promoPlans,
  } = usePromoPlans();

  const isLoading =
    isLoadingOffer || isLoadingPaymentSource || isLoadingPromoPlans;

  return {
    acceptOffer,
    allowIntervalSelection,
    error,
    isLoading,
    isOfferAvailable,
    isPaymentMethodProvided: Boolean(primarySource),
    isSaving,
    offer,
    offerEndDate,
    promoPlans,
    showModal: Boolean(
      !isLoading &&
      canShow && // user must be logged in and an offer id must be available
      !isOfferActive && // don't show the modal when the user's already on a promo plan
        !offer?.variant?.isControl // don't show the modal for experiment control groups
    ),
  };
};
